export default function BrandMark({ large = false }: { large?: boolean }) {
  return (
    <div className={`standalone-brand ${large ? 'large' : ''}`}>
      <span className="brand-mark" aria-hidden="true"><i /><i /><i /></span>
      <span>CanNTalk</span>
    </div>
  );
}
